import PromptConfiguration from "./PromptConfiguration";

export default PromptConfiguration;